import {createApi} from "@reduxjs/toolkit/dist/query/react";
import {apiQuery} from "../../utils/appConfig";
import {RedirectSelectDTO} from "../../types/short-url/RedirectSelectDTO";
import {RedirectCreationDTO} from "../../types/short-url/RedirectCreationDTO";
import {RedirectModificationDTO} from "../../types/short-url/RedirectModificationDTO";
import {PageDTO, Response} from "../../types/response/Response";
import {RedirectSelectionRequestDTO} from "../../types/short-url/RedirectSelectionRequestDTO";

export const redirectApi = createApi({
    reducerPath: 'shortUrl',
    baseQuery: apiQuery,
    tagTypes: ['redirect'],
    endpoints: builder => ({
        getRedirectList: builder.query<Response<PageDTO<RedirectSelectDTO>>, RedirectSelectionRequestDTO>({
            query: (body) => ({
                url: "/api/v1/redirects/list",
                method: 'POST',
                body
            }),
            providesTags: ['redirect']
        }),
        getRedirectListStrictly: builder.query<Response<PageDTO<RedirectSelectDTO>>, RedirectSelectionRequestDTO>({
            query: (body) => ({
                url: "/api/v1/redirects/list/strict",
                method: 'POST',
                body
            }),
            providesTags: ['redirect']
        }),
        createRedirect: builder.mutation<void, Partial<RedirectCreationDTO>>({
            query: (body) => ({
                url: '/api/v1/redirects',
                method: 'POST',
                body
            }),
            invalidatesTags: ['redirect']
        }),
        deleteRedirect: builder.mutation<void, number>({
            query: (id) => ({
                url: `/api/v1/redirects/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['redirect']
        }),
        deleteRedirectStrictly: builder.mutation<void, number>({
            query: (id) => ({
                url: `/api/v1/redirects/${id}/strict`,
                method: 'DELETE'
            }),
            invalidatesTags: ['redirect']
        }),
        updateRedirect: builder.mutation<RedirectSelectDTO, Partial<RedirectModificationDTO>>({
            query: (body) => ({
                url: `/api/v1/redirects/${body.id}`,
                method: 'PUT',
                body: {...body, id: undefined}
            }),
            invalidatesTags: ['redirect']
        }),
        updateRedirectStrictly: builder.mutation<RedirectSelectDTO, Partial<RedirectModificationDTO>>({
            query: (body) => ({
                url: `/api/v1/redirects/${body.id}/strict`,
                method: 'PUT',
                body: {...body, id: undefined}
            }),
            invalidatesTags: ['redirect']
        }),
    })
})

export const {
    useGetRedirectListQuery,
    useGetRedirectListStrictlyQuery,
    useCreateRedirectMutation,
    useDeleteRedirectMutation,
    useDeleteRedirectStrictlyMutation,
    useUpdateRedirectMutation,
    useUpdateRedirectStrictlyMutation
} = redirectApi